import { Component, OnInit } from '@angular/core';
import {ButtonModule} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {SharedModule} from "primeng/api";
import {TableModule} from "primeng/table";
import {ActivatedRoute} from "@angular/router";
import {BatchRegistersImportSuppliersInterface} from "../../../../interfaces/batch-registers-import-suppliers";
import {BatchRegistersImportSuppliersService} from "../../../../services/batch-registers-import-suppliers.service";

@Component({
    selector: 'app-batch-registers-import',
    standalone: true,
    imports: [
        ButtonModule,
        InputTextModule,
        SharedModule,
        TableModule
    ],
    templateUrl: './batch-registers-import.component.html',
    styleUrl: './batch-registers-import.component.scss'
})
export class BatchRegistersImportComponent implements OnInit{

    batch_registers_import_suppliers: BatchRegistersImportSuppliersInterface[];
    cols: any[] = [];
    uuid: string | null = null;

    constructor(private batchRegistersImportService: BatchRegistersImportSuppliersService,
                private route:ActivatedRoute) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.loadBatchRegistersImport();
        });
    }

    loadBatchRegistersImport(){
        this.batchRegistersImportService.getBatchRegistersImportSuppliers(this.uuid).subscribe(batch_registers_import_suppliers => {
            this.batch_registers_import_suppliers = batch_registers_import_suppliers;
        });
    }

}
